import './BrandHomeNavigation.css';
import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import {Link} from 'react-router-dom';
import {useEffect,useState} from 'react';
import {useAuth} from '@/context/AuthContext';
import {api,errMsg} from '@/lib/api';
import {brandExploreUrl,brandHomeUrl,cacheBrandHome} from '@/brandHome';

export function useBrandHomePreference(studio,relationshipId){
  const {user}=useAuth();
  const brand=studio?.brand_network?.slug;
  const [data,setData]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false),[retry,setRetry]=useState(0);
  useEffect(()=>{
    if(!brand||!relationshipId)return;
    let active=true;setData(null);setError('');
    api.put(`/client/brands/${encodeURIComponent(brand)}/home`,{relationship_id:relationshipId,only_if_unset:true})
      .then(value=>{if(active){setData(value);cacheBrandHome(brand,value.home);}})
      .catch(e=>{if(active)setError(errMsg(e));});
    return()=>{active=false;};
  },[brand,relationshipId,user?.id,retry]);
  const choose=async()=>{setBusy(true);setError('');try{const value=await api.put(`/client/brands/${encodeURIComponent(brand)}/home`,{relationship_id:relationshipId,only_if_unset:false});setData(value);cacheBrandHome(brand,value.home);}catch(e){setError(errMsg(e));}finally{setBusy(false);}};
  return {data,error,busy,choose,retry:()=>setRetry(n=>n+1)};
}

export default function BrandHomeNavigation({studio,relationshipId,preference,origin}){
  useUiLanguage();
  const brand=studio?.brand_network?.slug;
  const [open,setOpen]=useState(false);
  if(!brand)return null;
  const {data,error,busy,choose,retry}=preference;
  const current=data?.home?.relationship_id===relationshipId;
  return <section className="space-y-2" aria-label={tr("Navigazione Brand")}>
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" disabled={busy&&!open} aria-expanded={open} onClick={()=>setOpen(v=>!v)} className="client-brand-home-action bg-card">{tr("Sede")} <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="text-rose-500"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></button>
      <Link className="client-brand-home-action bg-card" to={brandExploreUrl(brand)}>{tr("Il Brand")}</Link>
    </div>
    {open&&<div className="rounded-2xl border border-white/10 bg-card/80 p-4 text-sm">
      <p className="text-sm">{current?tr("La tua sede preferita"):tr("Sei nella sede di {{0}}", {"0": studio.public?.city||studio.name})}</p>
      {origin&&<p className="mt-2 text-xs text-muted-foreground">{tr("Registrato a")} {origin.city||origin.studio_name}{origin.ownership_type==="artist"&&origin.artist_name?tr(" · Cliente di {{0}}", {"0": origin.artist_name}):tr(" · Cliente dello Studio")}</p>}
      {data&&!current&&<details className="mt-2 text-sm" open={open}><summary className="min-h-11 cursor-pointer py-3">{tr("Sede all’apertura:")} {data.home?.city||data.home?.name||tr("da scegliere")}</summary><div className="space-y-3 pb-2">{data.home&&<Link className="inline-flex min-h-11 items-center rounded-xl border px-4 no-underline" to={brandHomeUrl(brand,data.home.slug)}>{tr("Torna a")} {data.home.city||data.home.name}</Link>}<p className="text-muted-foreground">{tr("Scegli dove aprire l’app. La tua associazione allo Studio o al professionista resta invariata.")}</p><button disabled={busy} className="min-h-11 rounded-xl border px-4" onClick={choose}>{busy?tr("Salvataggio…"):tr("Apri sempre da questa sede")}</button></div></details>}
      {error&&<div role="alert" className="mt-2 text-sm"><p>{tr("Impossibile salvare la sede iniziale.")} {systemText(error)}</p><button className="min-h-11 rounded-xl border px-4" disabled={busy} onClick={retry}>{tr("Riprova")}</button></div>}
    </div>}
  </section>;
}

export function BrandHomeReturn({brandSlug}){
  useUiLanguage();
  const {status,user}=useAuth();
  const [home,setHome]=useState(null);
  useEffect(()=>{
    let active=true;setHome(null);
    if(status==='authed'&&user?.role==='client')api.get(`/client/brands/${encodeURIComponent(brandSlug)}/home`).then(value=>{if(active)setHome(value.home||(value.studios?.length===1?value.studios[0]:null));}).catch(()=>{});
    return()=>{active=false;};
  },[brandSlug,status,user?.id,user?.role]);
  return home?<Link className="brand-story-quick" to={brandHomeUrl(brandSlug,home.slug)}>{tr("La mia sede")} <span aria-hidden="true">›</span></Link>:null;
}
